import { call, put } from "redux-saga/effects";
import { validateResponse } from "sagas/ErrorSagas";
import DrawDBApi, {
  type FetchDrawDBAppsResponse,
  type FetchDrawDBRequest,
  type CreateDrawDBRequest,
  type SaveDrawDBRequest,
  type FetchDrawDBAppRequest,
  type UpdateDrawDBRequest,
} from "ee/api/DrawDBApi";
import history from "utils/history";
import { message } from "antd";

import type {
  ReduxAction,
  ReduxActionWithPromise,
} from "ee/constants/ReduxActionConstants";
import {
  ReduxActionTypes,
  ReduxActionErrorTypes,
} from "ee/constants/ReduxActionConstants";

import type { ApiResponse } from "api/ApiResponses";

export interface Response<T = unknown> {
  data: T;
  code?: string;
  headers?: any;
  config?: any;
}

export function* fetchDrawDBGroupsSaga(
  action?: ReduxAction<{ workspaceId?: string; fetchEntities: boolean }>,
) {
  try {
    const response: FetchDrawDBAppsResponse = yield call(
      DrawDBApi.fetchAllDrawDBGroups,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      const groups = response.data;
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_GROUPS_SUCCESS,
        payload: groups,
      });
      // if (action?.payload?.workspaceId || action?.payload?.fetchEntities) {
      //   yield call(fetchEntitiesOfWorkspaceSaga, action);
      // }
    }
  } catch (error) {
    // yield put({
    //   type: ReduxActionErrorTypes.FETCH_USER_APPLICATIONS_WORKSPACES_ERROR,
    //   payload: {
    //     error,
    //   },
    // });
    // yield put(safeCrashAppRequest(error));
  }
}

export function* fetchDrawDBAppsSaga(
  action?: ReduxAction<{ drawdbGroupId?: string; name?: string }>,
) {
  try {
    const request: FetchDrawDBRequest = {
      drawdbGroupId: action?.payload?.drawdbGroupId || "",
      name: action?.payload?.name || "",
    };
    const response: FetchDrawDBAppsResponse = yield call(
      DrawDBApi.fetchDrawDBApps,
      request,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      const workspaces = response.data;
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_APPS_SUCCESS,
        payload: workspaces,
      });
    }
  } catch (error) {}
}

export function* createDrawDBGroupSaga(action?: ReduxAction<{ name: string }>) {
  try {
    const request: CreateDrawDBRequest = {
      name: action?.payload?.name || "",
    };
    const response: ApiResponse = yield call(
      DrawDBApi.createDrawDBGroup,
      request,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.CREATE_DRAW_DB_GROUP_SUCCESS,
        payload: response.data,
      });
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_GROUPS_INIT,
        payload: {},
      });
    }
  } catch (error) {}
}

export function* updateDrawDBGroupSaga(
  action?: ReduxAction<{ id: string; name: string; onFailure?: () => void }>,
) {
  try {
    const request: UpdateDrawDBRequest = {
      id: action?.payload?.id || "",
      name: action?.payload?.name || "",
    };
    const response: ApiResponse = yield call(
      DrawDBApi.updateDrawDBGroup,
      request,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.UPDATE_DRAW_DB_GROUP_SUCCESS,
        payload: response.data,
      });
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_GROUPS_INIT,
        payload: {},
      });
    } else {
      if (action?.payload?.onFailure) {
        yield call(action?.payload?.onFailure);
      }
    }
  } catch (error) {
    if (action?.payload?.onFailure) {
      yield call(action?.payload?.onFailure);
    }
    throw error;
  }
}

export function* createDrawDBSaga(
  action?: ReduxAction<{
    name: string;
    dbType: string;
    drawdbGroupId: string;
    layout: any;
  }>,
) {
  try {
    const request: CreateDrawDBRequest = {
      name: action?.payload?.name || "",
      dbType: action?.payload?.dbType,
      drawdbGroupId: action?.payload?.drawdbGroupId,
      layout: action?.payload?.layout,
    };
    const response: ApiResponse = yield call(DrawDBApi.createDrawDB, request);
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.CREATE_DRAW_DB_SUCCESS,
        payload: response.data,
      });
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_APPS_INIT,
        payload: {
          drawdbGroupId: action?.payload?.drawdbGroupId,
        },
      });
    }
  } catch (error) {}
}

export function* fetchDrawDBAppSaga(action?: ReduxAction<{ id: string }>) {
  try {
    const request: FetchDrawDBAppRequest = {
      id: action?.payload?.id || "",
    };
    const response: ApiResponse = yield call(DrawDBApi.fetchDrawDBApp, request);
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_APP_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {}
}

export function* editDrawDBSaga(
  action?: ReduxAction<{
    id: string;
    name?: string;
    layout: any;
    drawdbGroupId: string;
    onFailure?: () => void;
  }>,
) {
  try {
    const request: any = {
      id: action?.payload?.id || "",
      name: action?.payload?.name,
      layout: action?.payload?.layout || {},
    };
    const response: ApiResponse = yield call(DrawDBApi.editDrawDB, request);
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.EDIT_DRAW_DB_SUCCESS,
        payload: response.data,
      });
      if (action?.payload?.drawdbGroupId) {
        yield put({
          type: ReduxActionTypes.FETCH_DRAW_DB_APPS_INIT,
          payload: {
            drawdbGroupId: action?.payload?.drawdbGroupId,
          },
        });
      }
    } else {
      if (action?.payload?.onFailure) {
        yield call(action?.payload?.onFailure);
      }
    }
  } catch (error) {
    if (action?.payload?.onFailure) {
      yield call(action?.payload?.onFailure);
    }
    throw error;
  }
}

export function* deleteDrawDBAppSaga(
  action?: ReduxAction<{ id: string; drawdbGroupId: string }>,
) {
  try {
    const request: any = {
      id: action?.payload?.id || "",
    };
    const response: ApiResponse = yield call(
      DrawDBApi.deleteDrawDBApp,
      request,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_APPS_INIT,
        payload: {
          drawdbGroupId: action?.payload?.drawdbGroupId,
        },
      });
      message.success("删除成功");
    }
  } catch (error) {}
}

export function* deleteDrawDBGroupSaga(action?: ReduxAction<{ id: string }>) {
  try {
    const request: any = {
      id: action?.payload?.id || "",
    };
    const response: ApiResponse = yield call(
      DrawDBApi.deleteDrawDBGroup,
      request,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.DELETE_DRAW_DB_GROUP_SUCCESS,
        payload: response.data,
      });
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_GROUPS_INIT,
        payload: {},
      });
      message.success("删除成功");
      history.push("/home");
    }
  } catch (error) {}
}

export function* exportDrawDBAppSaga(action?: ReduxAction<{ id: string }>) {
  try {
    const request: any = {
      id: action?.payload?.id || "",
    };
    const response: Response = yield call(DrawDBApi.exportDrawDBApp, request);
    const { headers, data, config } = response;
    const url = window.URL.createObjectURL(data as Blob);
    const fileName = headers
      .get("content-disposition")
      .match(/filename="?([^"]+)"?/)[1];
    const ele = document.createElement("a");
    ele.href = url;
    ele.download = `${fileName}`;
    document.body.appendChild(ele);
    ele.click();
    document.body.removeChild(ele);
    URL.revokeObjectURL(url);
    message.success("导出成功");
  } catch (error) {
    message.error("导出失败");
  }
}

export function* importDrawDBAppSaga(
  action?: ReduxAction<{ id: string; file: File }>,
) {
  try {
    const request: any = {
      id: action?.payload?.id || "",
      file: action?.payload?.file || "",
    };
    const response: ApiResponse = yield call(
      DrawDBApi.importDrawDBApp,
      request,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.IMPORT_DRAW_DB_APP_SUCCESS,
        payload: response.data,
      });
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_APPS_INIT,
        payload: {
          drawdbGroupId: action?.payload?.id,
        },
      });
    }
  } catch (error) {
    yield put({
      type: ReduxActionErrorTypes.IMPORT_DRAW_DB_APP_ERROR,
      payload: {
        error,
      },
    });
  }
}

export function* inviteUsersToDrawDBGroupSaga(
  action?: ReduxAction<{
    permissionGroupId: string;
    users: string[];
    drawdbGroupId: string;
  }>,
) {
  try {
    const request: any = {
      users: action?.payload?.users || [],
      permissionGroupId: action?.payload?.permissionGroupId || "",
    };
    const response: ApiResponse = yield call(
      DrawDBApi.inviteUsersToDrawDBGroup,
      request,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.INVITE_USERS_TO_DRAW_DB_GROUP_SUCCESS,
        payload: response.data,
      });
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_GROUP_USERS_INIT,
        payload: {
          id: action?.payload?.drawdbGroupId,
        },
      });
    }
  } catch (error) {}
}

export function* fetchDrawDBGroupUsersSaga(
  action?: ReduxAction<{ id: string }>,
) {
  try {
    const request: any = {
      id: action?.payload?.id || "",
    };
    const response: ApiResponse = yield call(
      DrawDBApi.fetchDrawDBGroupUsers,
      request,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_GROUP_USERS_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {}
}

export function* deleteDrawDBGroupMemberSaga(
  action?: ReduxAction<{
    permissionGroupId: string;
    users: any;
    drawdbGroupId: string;
  }>,
) {
  try {
    const request: any = {
      permissionGroupId: action?.payload?.permissionGroupId || "",
      users: action?.payload?.users || "",
    };
    const response: ApiResponse = yield call(
      DrawDBApi.deleteDrawDBGroupMember,
      request,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.DELETE_DRAW_DB_GROUP_MEMBER_SUCCESS,
        payload: response.data,
      });
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_GROUP_USERS_INIT,
        payload: {
          id: action?.payload?.drawdbGroupId,
        },
      });
    }
  } catch (error) {}
}

export function* fetchDrawDBPermissionGroupsSaga(
  action?: ReduxAction<{ id: string }>,
) {
  try {
    const request: any = {
      id: action?.payload?.id || "",
    };
    const response: ApiResponse = yield call(
      DrawDBApi.fetchDrawDBPermissionGroups,
      request,
    );
    const isValidResponse: boolean = yield validateResponse(response);
    if (isValidResponse) {
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_PERMISSION_GROUPS_SUCCESS,
        payload: response.data,
      });
      yield put({
        type: ReduxActionTypes.FETCH_DRAW_DB_GROUP_USERS_INIT,
        payload: {
          id: action?.payload?.id,
        },
      });
    }
  } catch (error) {}
}
